import React, { useState } from 'react';
import { CaseHeader } from '../components/CaseHeader';
import { DepositionOutline } from '../components/DepositionOutline';
import { FileTextIcon, SettingsIcon, UserIcon, Wand2Icon } from 'lucide-react';
export function DepositionPage() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 1500);
  };
  return <div className="flex flex-col h-full w-full overflow-hidden bg-navy" data-id="element-242">
      <CaseHeader data-id="element-243" />

      <div className="flex-1 overflow-hidden flex" data-id="element-244">
        {/* Left Panel - Controls */}
        <div className="w-[400px] border-r border-navy-border bg-navy-surface flex flex-col flex-shrink-0 overflow-y-auto" data-id="element-245">
          <div className="p-5 border-b border-navy-border" data-id="element-246">
            <h2 className="text-lg font-semibold text-white flex items-center gap-2" data-id="element-247">
              <FileTextIcon size={18} className="text-accent-amber" data-id="element-248" />
              Deposition Builder
            </h2>
            <p className="text-xs text-text-secondary mt-1" data-id="element-249">
              Generate structured outlines from the discovery record.
            </p>
          </div>

          <div className="p-5 space-y-6 flex-1" data-id="element-250">
            <div className="space-y-2" data-id="element-251">
              <label className="text-xs font-semibold text-text-muted uppercase tracking-wider flex items-center gap-2" data-id="element-252">
                <UserIcon size={14} data-id="element-253" />
                Deponent
              </label>
              <select className="input-field" data-id="element-254">
                <option value="" data-id="element-255">Select a witness...</option>
                <option value="smith" data-id="element-256">
                  John Smith (VP Construction, Blackstone)
                </option>
                <option value="johnson" data-id="element-257">
                  Mary Johnson (General Counsel, Blackstone)
                </option>
                <option value="davis" data-id="element-258">
                  Robert Davis (Site Manager, Greenfield)
                </option>
              </select>
            </div>

            <div className="space-y-2" data-id="element-259">
              <label className="text-xs font-semibold text-text-muted uppercase tracking-wider flex items-center gap-2" data-id="element-260">
                <SettingsIcon size={14} data-id="element-261" />
                Focus Topics (Optional)
              </label>
              <div className="space-y-2" data-id="element-262">
                <label className="flex items-center gap-2 text-sm text-text-secondary cursor-pointer hover:text-white transition-colors" data-id="element-263">
                  <input type="checkbox" className="rounded-sm border-navy-border bg-navy text-accent-amber focus:ring-accent-amber focus:ring-offset-navy" defaultChecked data-id="element-264" />
                  Contract Drafting & Review
                </label>
                <label className="flex items-center gap-2 text-sm text-text-secondary cursor-pointer hover:text-white transition-colors" data-id="element-265">
                  <input type="checkbox" className="rounded-sm border-navy-border bg-navy text-accent-amber focus:ring-accent-amber focus:ring-offset-navy" defaultChecked data-id="element-266" />
                  Notice of Water Intrusion
                </label>
                <label className="flex items-center gap-2 text-sm text-text-secondary cursor-pointer hover:text-white transition-colors" data-id="element-267">
                  <input type="checkbox" className="rounded-sm border-navy-border bg-navy text-accent-amber focus:ring-accent-amber focus:ring-offset-navy" data-id="element-268" />
                  Damages Calculation
                </label>
                <label className="flex items-center gap-2 text-sm text-text-secondary cursor-pointer hover:text-white transition-colors" data-id="element-269">
                  <input type="checkbox" className="rounded-sm border-navy-border bg-navy text-accent-amber focus:ring-accent-amber focus:ring-offset-navy" data-id="element-270" />
                  Subcontractor Communications
                </label>
              </div>
            </div>

            <div className="space-y-2" data-id="element-271">
              <label className="text-xs font-semibold text-text-muted uppercase tracking-wider" data-id="element-272">
                Custom Instructions / Prompt
              </label>
              <textarea className="input-field min-h-[120px] resize-none text-sm" placeholder="e.g., Focus heavily on contradictions between ROG 3 and the daily site logs regarding the timeline of when they knew about the pooling water. Include specific Bates numbers for exhibits." defaultValue="Focus heavily on contradictions between ROG 3 and the daily site logs regarding the timeline of when they knew about the pooling water. Include specific Bates numbers for exhibits." data-id="element-273" />
            </div>
          </div>

          <div className="p-5 border-t border-navy-border bg-navy" data-id="element-274">
            <button onClick={handleGenerate} disabled={isGenerating} className="btn-primary w-full flex justify-center items-center gap-2 py-3" data-id="element-275">
              {isGenerating ? <span className="flex items-center gap-2" data-id="element-276">
                  <div className="w-4 h-4 border-2 border-navy border-t-transparent rounded-full animate-spin" data-id="element-277"></div>
                  Analyzing Record...
                </span> : <span className="flex items-center gap-2" data-id="element-278">
                  <Wand2Icon size={16} data-id="element-279" />
                  Generate Deposition Outline
                </span>}
            </button>
          </div>
        </div>

        {/* Right Panel - Outline View */}
        <div className="flex-1 bg-[#0A121C] p-6 overflow-hidden" data-id="element-280">
          {hasGenerated ? <div className="h-full animate-in fade-in zoom-in-95 duration-300" data-id="element-281">
              <DepositionOutline data-id="element-282" />
            </div> : <div className="h-full flex flex-col items-center justify-center text-text-muted border-2 border-dashed border-navy-border rounded-sm" data-id="element-283">
              <FileTextIcon size={48} className="mb-4 opacity-20" data-id="element-284" />
              <p className="text-sm" data-id="element-285">
                Select a deponent and generate an outline to view it here.
              </p>
              <p className="text-xs mt-2 opacity-60" data-id="element-286">
                The outline will cross-reference all available discovery
                responses.
              </p>
            </div>}
        </div>
      </div>
    </div>;
}